import dt from './dt';
import mt from './mt';
import about from './about';
import priceIndicative from './priceIndicative';
import price from './price';

export default {
  dt,
  mt,
  about,
  priceIndicative,
  price,
};
